import { React, useEffect, useState } from "react";
import {
    Stack, Table, TableBody, TableCell, TableContainer, Typography,
    TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Input
} from '@mui/material';
import { Buffer } from 'buffer';
import { useFormContext } from "react-hook-form";

export default function ImportAddressesDialog({ open, handleClose, title }) {
  const [headers, setHeaders] = useState();
  const [rows, setRows] = useState();
  const [error, setError] = useState(null);
  const { setValue } = useFormContext();

  useEffect(() => {
    setRows(null);
    setHeaders(null);
    setError(null);
  }, [open]);

  const importDatas = () => {
    const addressItems = [];
    console.log(rows);
    for (let row of rows) {
        const addressItem = {
        title: row[0],
        addressLine1: row[1],
        addressLine2: row[2],
        addressLine3: row[3],
        addressLine4: row[4],
        addressLine5: row[5],
        addressLine6: row[6],
      };
      addressItems.push(addressItem);
    }
    setValue("resiliationModelAddresses", addressItems, { shouldDirty: true });
    handleClose();
  };

  const handleCapture = async (event) => {
    setError();
    const fileContent = await readFileContent(event.target.files[0]);
    let index = 0;
    const rowItems = [];
    let headerItems = null;
    console.log(fileContent);
    for (let line of fileContent.split("\n")) {
      console.log(line);
      if (index === 0) {
        headerItems = line.split(",");
      } else {
        const items = line.split(",");
        // if (!isNullOrEmpty(items[0]) && !isNullOrEmpty(items[1]) && !isNullOrEmpty(items[2]) && !isNullOrEmpty(items[3]) && !isNullOrEmpty(items[4]) && !isNullOrEmpty(items[5]) && !isNullOrEmpty(items[6]) && !isNullOrEmpty(items[7])) {
        if (
          !isNullOrEmpty(items[0]) &&
          !isNullOrEmpty(items[1]) &&
          !isNullOrEmpty(items[6])
        ) {
          const cleanedItem = [];
          for (let i = 0; i < 8; i++) {
            console.log(items[i]);
            cleanedItem.push(
              !isNullOrEmpty(items[i]) && items[i] !== undefined
                ? items[i].trim().replace("\r", "").replace("\n", "")
                : items[i]
            );
          }
          rowItems.push(cleanedItem);
        }
      }
      index++;
    }
    console.log(rowItems);
    if (headerItems == null || headerItems.length !== 7) {
      setError("Le fichier ne contient pas 7 colonnes");
    } else {
      setHeaders(headerItems);
      setRows(rowItems);
    }
  };

  const isNullOrEmpty = (value) => {
    return value == null || value === undefined || value === "";
  };

  const readFileContent = async (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        const fileContent = Buffer.from(
          e.target.result.split(";base64,")[1],
          "base64"
        ).toString("utf8");
        resolve(fileContent);
      };
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
        Import des adresses pour {title}{" "}
      </DialogTitle>
      <DialogContent>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={5}
        >
          <Typography fontSize={18} color="error">
            Attention !!! En validant l'import de données, l'ensemble des
            adresses seront remplacées
            <br />
            Le fichier doit :
            <ul>
              <li>Etre au format CSV, séparé par des virgules.</li>
              <li>
                title, addressLine1 et addressLine6 sont
                obligatoires!!!!!!!!!!!!!!!
              </li>
              <li>
                Contenir uniquement 7 colonnes : title, addressLine1,
                addressLine2, addressLine3, addressLine4, addressLine5,
                addressLine6
              </li>
              <li>
                Une ligne d'entête avec les valeurs suivantes : title,
                addressLine1, addressLine2, addressLine3, addressLine4,
                addressLine5, addressLine6
              </li>
            </ul>
            Voici le détail des informations d'adresse :
            <ul>
              <li>Ligne d'adresse n°1 (Société) du destinataire</li>
              <li>
                Ligne d'adresse n°2 (Civilité, Prénom, Nom) du destinataire
              </li>
              <li>
                Ligne d'adresse n°3 (Résidence, Bâtiment ...) du destinataire
              </li>
              <li>
                Ligne d'adresse n°4 (N° et libellé de la voie) du destinataire
              </li>
              <li>Ligne d'adresse n°5 (Lieu dit, BP...) du destinataire</li>
              <li>
                Ligne d'adresse n°6 (Code postal et ville) du destinataire
              </li>
            </ul>
          </Typography>
          <label htmlFor="id-check">
            <Input
              accept="text/csv"
              inputProps={{ accept: "text/csv" }}
              id="id-check"
              type="file"
              sx={{ display: "none" }}
              onChange={(event) => handleCapture(event)}
            />
            <Button
              variant="outlined"
              sx={{
                color: "#5C5C5C",
                padding: "28px 107px",
                borderRadius: "7px",
                borderColor: "#C4C4C4!important",
              }}
              component="span"
            >
              Choisir le fichier
            </Button>
            {error != null && (
              <Typography>
                Le fichier ne contient pas le bon nombre de colonne
              </Typography>
            )}
          </label>
          {headers != null &&
            headers.length > 0 &&
            rows != null &&
            rows.length > 0 && (
              <>
                <Typography
                  fontSize={18}
                  color="error"
                  sx={{ textAlign: "center" }}
                >
                  Vérifiez les données avant de cliquer sur importer
                </Typography>
                <BasicTable headers={headers} rows={rows} />
              </>
            )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Annuler
        </Button>
        <Button
          disabled={
            !(
              error == null &&
              headers != null &&
              headers.length === 7 &&
              rows != null &&
              rows.length > 0
            )
          }
          onClick={() => importDatas()}
          color="primary"
          autoFocus
        >
          Importer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function BasicTable({ headers, rows }) {

    useEffect(() => {
    }, [headers, rows])

    return (
        <TableContainer component={Paper} sx={{ height: "500px" }}>
            <Table stickyHeader sx={{ minWidth: 750 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {
                            headers.map((h) => (
                                <TableCell key={h}>{h}</TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow
                            key={row}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            {
                                row.map((item) => (
                                    <TableCell component="th" scope="row">
                                        {item}
                                    </TableCell>
                                ))
                            }
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}